import * as THREE from 'three';
import { GUI } from 'three/addons/libs/lil-gui.module.min.js';

export default class Debug{
	constructor(plan){
		this.gui = new GUI();

		const guiChanged = () => {
			// plan.products.forEach(product => {
			// 	// if (product.states.filtered){
			// 		product.planProduct.updateAppearance();
			// 	// }
			// });

			// Sun
			plan.sun.color.set(plan.settings.sunLight.color.color);
			plan.sun.intensity = plan.settings.sunLight.intensity;
			plan.scene.environmentIntensity = plan.settings.environmentIntensity;

			// Sky
			// plan.sky.settings.azimuth = values.sky.x;
			// plan.sky.settings.elevation = values.sky.y;
			// plan.sky.settings.exposure = values.sky.exposure;

			// Hemisphere
			plan.hemisphere.color.set(plan.settings.hemisphereLight.color.color);
			plan.hemisphere.groundColor.set(plan.settings.hemisphereLight.groundColor.color);
			plan.hemisphere.intensity = plan.settings.hemisphereLight.intensity;

			// Model
			plan.model.position.x = plan.settings.model.position.x;
			plan.model.position.y = plan.settings.model.position.y;
			plan.model.position.z = plan.settings.model.position.z;
			plan.model.rotation.y = THREE.MathUtils.degToRad(plan.settings.model.rotation);
			plan.model.scale.set(plan.settings.model.scale, plan.settings.model.scale, plan.settings.model.scale);

			plan.products.forEach(product => {
				product.object.scale.setScalar(plan.settings.model.hitboxScale);
			})

			// Camera
			plan.controls.maxPolarAngle = THREE.MathUtils.degToRad(plan.settings.maxPolarAngle);
			plan.camera.far = plan.settings.camera.far;

			plan.render();
		}

		const landscapeChanged = () => {
			const settings = clip;

			cube.geometry = new THREE.BoxGeometry(settings.dimension.x, settings.dimension.y, settings.dimension.z);
			cube.position.set(settings.position.x, settings.position.y, settings.position.z);
			cube.rotation.y = THREE.MathUtils.degToRad(settings.rotation);

			plan.render();
		};
		
		const materialChange = () => {
			plan.planService.products.forEach(product => {
				product.updateState();
			})
			
			plan.render();
		};

		const guiItem = {};

		// Model
		guiItem.model = this.gui.addFolder('Model');
		guiItem.model.add(plan.settings.model, 'rotation', 0, 360, .1).name('Rotation').onChange(guiChanged);
		guiItem.model.add(plan.settings.model, 'scale', .25, 2.5, .001).name('Scale').onChange(guiChanged);
		guiItem.model.add(plan.settings.model.position, 'x', -100, 100, .05).name('Position X').onChange(guiChanged);
		guiItem.model.add(plan.settings.model.position, 'y', -100, 100, .05).name('Position Y').onChange(guiChanged);
		guiItem.model.add(plan.settings.model.position, 'z', -100, 100, .05).name('Position Z').onChange(guiChanged);
		guiItem.model.add(plan.settings.model, 'hitboxScale', .9, 1.1, .001).name('Hitbox scale').onChange(guiChanged);
		guiItem.model.close();

		// Camera
		guiItem.camera = this.gui.addFolder('Camera');
		guiItem.camera.add(plan.settings, 'maxPolarAngle', 0, 90, 1).name('Max vertical angle').onChange(guiChanged);
		guiItem.camera.add(plan.settings.camera, 'far', 500, 2500, 10).name('Far').onChange(guiChanged);
		guiItem.camera.close();

		// Landscape
		// guiItem.landscape = this.gui.addFolder('Landscape clip');
		// guiItem.landscape.add(clip.dimension, 'x', -500, 500, .05).name('Width X').onChange(landscapeChanged);
		// guiItem.landscape.add(clip.dimension, 'z', -500, 500, .05).name('Depth Z').onChange(landscapeChanged);
		// guiItem.landscape.add(clip.dimension, 'y', -500, 500, .05).name('Height Y').onChange(landscapeChanged);
		// guiItem.landscape.add(clip.position, 'x', -100, 100, .05).name('Pos X').onChange(landscapeChanged);
		// guiItem.landscape.add(clip.position, 'z', -100, 100, .05).name('Pos Z').onChange(landscapeChanged);
		// guiItem.landscape.add(clip.position, 'y', -100, 100, .05).name('Pos Y').onChange(landscapeChanged);
		// guiItem.landscape.add(clip, 'rotation', 0, 360, 1).name('Rotation').onChange(landscapeChanged);
		// guiItem.landscape.close();

		// Sun
		guiItem.sun = this.gui.addFolder('Sun light');
		guiItem.sun.add(plan.settings.sunLight, 'intensity', .1, 10, .1).name('Intensity').onChange(guiChanged);
		guiItem.sun.addColor(plan.settings.sunLight.color, 'color').name('Color').onChange(guiChanged);
		guiItem.sun.add(plan.settings, 'environmentIntensity', .1, 1, .05).name('Env Intensity').onChange(guiChanged);
		guiItem.sun.close();

		// Sky
		// guiItem.sky = this.gui.addFolder('Sun light');
		// guiItem.sky.add(plan.settings.sunLight, 'intensity', .1, 4, .1).name('Intensity').onChange(guiChanged);
		// guiItem.sky.addColor(plan.settings.sunLight.color, 'color').name('Color').onChange(guiChanged);
		// guiItem.sky.close();

		// Hemispherere
		/*
		guiItem.hemisphere = this.gui.addFolder('Hemisphere light');
		guiItem.hemisphere.addColor(plan.settings.hemisphereLight.color, 'color').name('Color').onChange(guiChanged);
		guiItem.hemisphere.addColor(plan.settings.hemisphereLight.groundColor, 'color').name('Ground color').onChange(guiChanged);
		guiItem.hemisphere.add(plan.settings.hemisphereLight, 'intensity', 0, 2, .1).name('Intensity').onChange(guiChanged);
		guiItem.hemisphere.close();
		*/
		// Materials
		(['Hidden', 'Unavailable', 'Filtered', 'Available', 'Highlighted']).forEach(state => {
			const key = state.toLowerCase();
			console.log({state, key});

			guiItem[key] = this.gui.addFolder(state);
			guiItem[key].addColor(plan.settings.materials[key], 'color').onChange(materialChange);
			guiItem[key].addColor(plan.settings.materials[key], 'emissive').onChange(materialChange);
			guiItem[key].add(plan.settings.materials[key], 'emissiveIntensity', 0, 1, .05).onChange(materialChange);			
			guiItem[key].add(plan.settings.materials[key], 'opacity', 0, 1, .05).onChange(materialChange);			
			guiItem[key].close();
		});
		/*
		guiItem.filtered = this.gui.addFolder('Filtered');
		guiItem.filtered.addColor(plan.settings.materials.filtered.fill, 'color').onChange(guiChanged);
		guiItem.filtered.add(plan.settings.materials.filtered.fill, 'opacity', 0, 1, .1).onChange(guiChanged);			
		guiItem.filtered.addColor(plan.settings.materials.filtered.stroke, 'color').onChange(guiChanged);
		guiItem.filtered.add(plan.settings.materials.filtered.stroke, 'opacity', 0, 1, .1).onChange(guiChanged);
		guiItem.filtered.close();

		guiItem.hover = this.gui.addFolder('Hover');
		guiItem.hover.addColor(plan.settings.materials.hover.fill, 'color').onChange(guiChanged);
		guiItem.hover.add(plan.settings.materials.hover.fill, 'opacity', 0, 1, .1).onChange(guiChanged);			
		guiItem.hover.addColor(plan.settings.materials.hover.stroke, 'color').onChange(guiChanged);
		guiItem.hover.add(plan.settings.materials.hover.stroke, 'opacity', 0, 1, .1).onChange(guiChanged);
		guiItem.hover.close();
		*/
		// guiChanged();

		// Camera info
		/*
		this.info = document.createElement('div');
		
		info.setAttribute('style', '
			position: fixed;
			inset: auto auto 1rem 1rem;
			z-index: 99999;
			display: flex;
			flex-direction: column;
			gap: .5em;
			font-size: 10px;
		');

		this.info.innerHTML = `
			<div style="position: fixed; inset: auto auto 1rem 1rem; z-index: 99999; display: flex; flex-direction: column; gap: .5em; font-size: 10px;">
				<div class="debug-zoom">120</div>
			</div>
		`;
		*/
		// Landscape clipping drawer
		new PolygonDrawer(plan);

		// Camera info
		this.info = new DebugInfo(plan.spot);
	}

	update(engine){
		this.info.update(engine);
	}
}

// Polygon draw (dev)
class PolygonDrawer{
	constructor(plan){
		this.plan = plan;
		this.drawMode = false;
		this.shape = null;

		const raycaster = new THREE.Raycaster();
		const mouse = new THREE.Vector2();
		const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0); // Y-plane

		const points = []; // THREE.Vector3
		const pointSpheres = []; // optional visual markers

		this.plan.renderer.domElement.addEventListener('click', (event) => {
			if (!this.drawMode) return;
			
			console.log(event);
			// convert mouse to normalized device coordinates
			mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
			mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;

			raycaster.setFromCamera(mouse, this.plan.camera);

			const intersection = new THREE.Vector3();
			raycaster.ray.intersectPlane(plane, intersection);

			if (intersection) {
				points.push(intersection.clone());

				const sphere = new THREE.Mesh(new THREE.SphereGeometry(0.2), new THREE.MeshBasicMaterial({ color: 0xff0000 }));
				sphere.position.copy(intersection);
				
				this.plan.scene.add(sphere);
				pointSpheres.push(sphere);
			}

			this.plan.render();
		});

		window.addEventListener('keydown', (e) => {
			if (e.key === 'CapsLock') {
				this.drawMode = !this.drawMode;
				console.warn('Draw mode ' + (this.drawMode ? 'enabled' : 'disabled'));
			}

			if (!this.drawMode) return;

			// Clear points
			if (e.key === 'Delete') {
				points.length = 0; // clear points
				pointSpheres.forEach(s => this.plan.scene.remove(s));
				pointSpheres.length = 0;

				this.deleteShape();

				this.plan.render();
			}

			// Close shape
			if (e.key === 'Enter') {
				function isClockwise(points) {
					let sum = 0;
					
					for (let i = 0; i < points.length; i++) {
						const v1 = points[i];
						const v2 = points[(i + 1) % points.length];
						sum += (v2.x - v1.x) * (v2.z + v1.z);
					}
					
					return sum > 0;
				}

				if (isClockwise(points)) {
					points.reverse();
				}
				
				// Print for manual copy/paste
				const payload = points.map(vector3 => [vector3.x, vector3.z]);
				console.log(payload);

				// Delete current shape
				this.deleteShape();
				
				// Create new shape
				this.shape = this.createShape(points);
				this.plan.scene.add(this.shape);
				
				// Clear points
				points.length = 0;
				pointSpheres.forEach(s => this.plan.scene.remove(s));
				pointSpheres.length = 0;

				this.plan.render();
			}
		});
	}

	createShape(points) {
		if (points.length < 3) return;

		// Project to XZ plane (Y=0)
		const vertices2D = points.map(v => new THREE.Vector2(v.x, v.z));

		const shape = new THREE.Shape(vertices2D);
		const shapeGeo = new THREE.ShapeGeometry(shape);

		const mesh = new THREE.Mesh(shapeGeo, new THREE.MeshBasicMaterial({
			color: 0x0000ff,
			side: THREE.DoubleSide,
			transparent: true,
			opacity: 0.5
		}));

		// Place it at Y=0
		mesh.position.y = 0;

		// Align with horizontal plan (me)
		mesh.rotation.x = Math.PI / 2;

		return mesh;
	}

	deleteShape(){		
		if (this.shape) {
			this.plan.scene.remove(this.shape);
			this.shape = null;
		}
	}
}

class DebugInfo{
	constructor(node){
		this.box = document.createElement('div');
		
		// this.box.setAttribute('style', '
		// 	position: fixed;
		// 	inset: auto auto 1rem 1rem;
		// 	z-index: 99999;
		// 	display: flex;
		// 	flex-direction: column;
		// 	gap: .5em;
		// 	font-size: 10px;
		// ');

		this.box.innerHTML = `
			<div style="position: fixed; inset: auto auto 1rem 1rem; padding: 1em; border-radius: 6px; background: rgba(255, 255, 255, .5); z-index: 99999; display: flex; flex-direction: column; gap: .5em; font-size: 10px;">
				<div class="debug-distance" style="display: flex; gap: .5rem;"><b>Zoom</b> <div>-</div></div>
				<div class="debug-angle-x" style="display: flex; gap: .5rem;"><b>Angle X</b> <div>-</div></div>
				<div class="debug-angle-y" style="display: flex; gap: .5rem;"><b>Angle Y</b> <div>-</div></div>
			</div>
		`;
		
		node.appendChild(this.box);

		this.nodes = {
			distance: this.box.querySelector('.debug-distance > div'),
			angleX: this.box.querySelector('.debug-angle-x > div'),
			angleY: this.box.querySelector('.debug-angle-y > div'),
		}
	}

	updateNode(key, value, decimal = 2){
		value = decimal === 0 ? Math.round(value) : Math.round(value * 10 * decimal) / (10 * decimal);
		this.nodes[key].textContent = value;
	}

	update(engine){
		this.updateNode('distance', engine.controls.getDistance(), 0);
		this.updateNode('angleX', 180 - THREE.MathUtils.radToDeg(engine.controls.getAzimuthalAngle()));
		this.updateNode('angleY', 90 - THREE.MathUtils.radToDeg( engine.controls.getPolarAngle() ));
		// this.updateNode('angleY', -1 * THREE.MathUtils.radToDeg(engine.controls.getPolarAngle() - Math.PI/2));
	}
}
